(() => {
  const storageKey = 'biguazul-color-scheme';
  const root = document.documentElement;
  const button = document.querySelector('[data-theme-toggle]');
  const media = window.matchMedia('(prefers-color-scheme: dark)');

  const applyTheme = (scheme) => {
    root.dataset.colorScheme = scheme;
    root.style.colorScheme = scheme;
    window.dispatchEvent(new CustomEvent('biguazul:themechange', { detail: { scheme } }));
    if (button) {
      button.setAttribute('aria-pressed', String(scheme === 'dark'));
      button.classList.toggle('is-dark', scheme === 'dark');
      button.classList.toggle('is-light', scheme === 'light');
    }
  };

  const getStoredTheme = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const getSystemTheme = () => (media.matches ? 'dark' : 'light');

  const initializeTheme = () => {
    const storedTheme = getStoredTheme();
    const initialTheme = storedTheme || getSystemTheme();
    applyTheme(initialTheme);
  };

  initializeTheme();

  if (button) {
    button.addEventListener('click', () => {
      const nextTheme = root.dataset.colorScheme === 'dark' ? 'light' : 'dark';
      applyTheme(nextTheme);

      try {
        window.localStorage.setItem(storageKey, nextTheme);
      } catch (error) {
        // Ignore storage failures.
      }
    });
  }

  media.addEventListener('change', () => {
    if (!getStoredTheme()) {
      applyTheme(getSystemTheme());
    }
  });
})();
